type HighlightTextStyles = Readonly<{
	backgroundColor: string;
	selectedBackgroundColor: string;
	borderColor: string;
	selectedBorderColor: string;
	textColor: string;
	selectedTextColor: string;
	iconColor: string;
	selectedIconColor: string;
}>;

type Result = ModelHookResult<HighlightTextStyles, undefined>;

const HIGHLIGHT_TEXT_STYLES: HighlightTextStyles = {
	backgroundColor: 'sunrise.semantic.fill.weaker',
	selectedBackgroundColor: 'sunrise.semantic.fill.accent.primary.strong',
	borderColor: 'transparent',
	selectedBorderColor: 'sunrise.semantic.fill.accent.primary.weaker',
	textColor: 'sunrise.semantic.typography.strong',
	selectedTextColor: 'sunrise.semantic.typography.inverse.strong',
	iconColor: 'sunrise.semantic.icon.strong',
	selectedIconColor: 'sunrise.semantic.icon.inverse.strong',
};

export function useHighlightText(): Result {
	return { data: HIGHLIGHT_TEXT_STYLES };
}
